'use strict';

import store from 'client/store';

import rankingLib from 'client/lib/ranking'

import find from "lodash/find";
import forEach from "lodash/forEach";
import map from "lodash/map";
import merge from "lodash/merge";

export default {

  getFormat: function (categoryId, roundIndex) {
    const category = find(store.state.categories.items, item => item.id === categoryId)
    const categoryRound = find(category.rounds, item => item.roundIndex === roundIndex)
    return find(store.state.eventDiscipline.formats, item => item.id === categoryRound.formatId)
  },

  /** get combined exercise configuration based on inherited configurations */
  getConfiguration: function (category, roundIndex, exerciseTypeId = null) {
    const discipline = store.state.eventDiscipline.discipline
    const format = this.getFormat(category.id, roundIndex)

    let exerciseTypeConfig = {}
    let formatExerciseTypeConfig = {}

    if (exerciseTypeId) {
      const exerciseType = find(store.state.eventDiscipline.exerciseTypes, i => i.id === exerciseTypeId)
      if (exerciseType) {
        exerciseTypeConfig = exerciseType.config

        const formatExerciseType = find(format.exercises, i => i.exerciseTypeId === exerciseTypeId)

        if (formatExerciseType) {
          formatExerciseTypeConfig = formatExerciseType.config
        }
      }
    }

    let options = {}
    const catRound = category.rounds.find(r => r.roundIndex === roundIndex)
    if (catRound) {
      options = catRound.config
    }

    const configuration = {}
    merge(configuration,
      discipline.config,
      options,
      exerciseTypeConfig,
      format.config,
      formatExerciseTypeConfig
    )

    return configuration
  },

  getCategoryExerciseTypes: function (categoryId, roundIndex) {
    const category = find(store.state.categories.items, item => item.id === categoryId)
    if (! category) {
      console.log('category not found', categoryId)
      return []
    }
    const categoryRound = find(category.rounds, item => item.roundIndex === roundIndex)
    const format = this.getFormat(categoryId, roundIndex)
    if (!format) return []

    let exerciseTypes = this.getExerciseTypes(format)

    if (categoryRound.config?.exerciseTypes && categoryRound.config?.exerciseTypes.length) {
      exerciseTypes = exerciseTypes.filter(i => categoryRound.config.exerciseTypes.includes(i))
    }
    return exerciseTypes
  },

  getFormatExerciseTypes: function (categoryId, roundIndex) {
    const format = this.getFormat(categoryId, roundIndex)
    return this.getExerciseTypes(format)
  },

  getExerciseTypes: function (format) {
    return map(format.exercises, item => item.exerciseTypeId)
  },

  getMainRankings: function (category, session) {
    let rankings = [];
    forEach(session.rankingTypes, type => {
      let exerciseTypes = ['']
      let includeType = 'regular'
      if (type.open) {
        includeType = 'open';
      } else if (!type.regular) {
        return;
      }

      if (type.rankingType === 'EVENTS') {
        exerciseTypes = this.getFormatExerciseTypes(category.id, session.roundIndex).filter(fe => {
          if (session.exerciseTypes?.length) {
            return session.exerciseTypes.includes(fe)
          }
          return true
        })
      }

      exerciseTypes.forEach(exerciseType => {
        const ranking = rankingLib.getRanking(category.id, session.roundIndex, type.rankingType, includeType, null, exerciseType)
        if (ranking) {
          rankings.push(ranking);
        }
      })
    });

    return rankings;
  },
}

